// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import AdminDashboard from "./components/AdminDashboard";
import PaidUserDashboard from "./components/PaidUserDashboard";
import CreatorDashboard from "./components/CreatorDashboard";
import ProfilePage from "./components/ProfilePage";
import FreeVideosPage from "./components/FreeVideosPage";
import ProtectedRoute from './components/ProtectedRoute';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";


// Inside <Routes>


const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/admin" element={<AdminDashboard />} /> */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute role="admin">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      
        <Route path="/user-dashboard" element={<PaidUserDashboard />} />
        <Route path="/creator" element={<CreatorDashboard />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/free-videos" element={<FreeVideosPage />} />
      </Routes>
    </Router>
  );
};

export default App;
